import { render } from "./PlannerLevelTwo.vue?vue&type=template&id=dcc9e880&ts=true"
import script from "./PlannerLevelTwo.ts?vue&type=script&lang=ts&external"
export * from "./PlannerLevelTwo.ts?vue&type=script&lang=ts&external"

import "../../../LevelTwo/LevelTwo.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__